import React, { Component } from 'react';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';
import { Toast } from 'antd-mobile/lib';
import { Picker,List} from 'antd-mobile/lib';
import arrayTreeFilter from 'array-tree-filter';
import Util from '../../../util'
import '../investPlan/InvestmentPlan.css'
import './Pay.css'
import {protocolCode,bankCode } from '../../../BankCode'
import { getTradeInfo2 ,getLimitAmount} from '../../../action/productAction';
import NavigatorMain from '../../NavigatorMain';
import PayWarmTips from './PayWarmTips';
import { myPaymentText } from '../../../action/publicAction';
import { getInvestmentDetial,modifyPlan,modifyBuyPlan,moneyFundPlanModifyValidate} from '../../../action/myAssets/InvestPlanAction.js';
import {getSuperFundProductIncome} from '../../../action/portfolioAction'

const CustomChildren = props => (
  <div
    onClick={props.onClick}
    className='text-bar'
  >
      <p>{props.children}</p>
      <p>{props.extra}<div className='toBottom' style={{ marginRight: '-13px'}}></div></p>
  </div>
);
var accountTip;
var account;
class FixedInvestmentSuperFund extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pickerValue:[0,1],
      agreeIndex:0,
      pwdFlag:false,
      keyPasswordVal:'',
      amount:'',
      dayIncomeDate:'',
      ThreeIncome:'',
      dataSouse:[
        {
          label: '每月',
          value: 0,
          key:0,
          children:[
            {label:'1日',value:1,key:0},
            {label:'2日',value:2,key:1},
            {label:'3日',value:3,key:2},
            {label:'4日',value:4,key:3},
            {label:'5日',value:5,key:4},
            {label:'6日',value:6,key:5},
            {label:'7日',value:7,key:6},
            {label:'8日',value:8,key:7},
            {label:'9日',value:9,key:8},
            {label:'10日',value:10,key:9},
            {label:'11日',value:11,key:10},
            {label:'12日',value:12,key:11},
            {label:'13日',value:13,key:12},
            {label:'14日',value:14,key:13},
            {label:'15日',value:15,key:14},
            {label:'16日',value:16,key:15},
            {label:'17日',value:17,key:16},
            {label:'18日',value:18,key:17},
            {label:'19日',value:19,key:18},
            {label:'20日',value:20,key:19},
            {label:'21日',value:21,key:20},
            {label:'22日',value:22,key:21},
            {label:'23日',value:23,key:22},
            {label:'24日',value:24,key:23},
            {label:'25日',value:25,key:24},
            {label:'26日',value:26,key:25},
            {label:'27日',value:27,key:26},
            {label:'28日',value:28,key:27}
          ]
        }
      ],
    };
  }
  componentWillMount(){
    document.title= "定投计划修改";
    let {fundCode,productType}=this.props.location.state;
    let dataAmount={
        tradeType:'T022',
        fundCode:fundCode,
    }
    this.props.dispatch(getTradeInfo2(fundCode,'T522',productType));
    this.props.dispatch(getLimitAmount(dataAmount,(val)=>{this.setState({amount:val})}))
    let inData = {
      superFundCode:fundCode,
      periodType:0
    }
    this.props.dispatch(getSuperFundProductIncome(inData,(data)=>{
      let leng = data.incomeDateList.length - 1;
        let dataP = (data.incomeList[leng] + 1)/(data.incomeList[0] + 1)
        let nH = Math.pow(dataP,240/(leng + 1)) - 1;
        let yearIncomeRate = Util.fomatFloat(nH*100);/*年化收益率*/
        this.setState({
          ThreeIncome:yearIncomeRate,
          dayIncomeDate:data.incomeDateList[leng].replace(/\//g,"-")
        })
    },this))
    this.setState({
      pickerValue:[0,this.props.location.state.planItem.tradeDates[0]],
    });
  }
  onChangePwd(val){
    this.setState({
      keyPasswordVal:val
    })
  }
  onChangeText(text){
    this.props.dispatch(myPaymentText(text))
  }
  ProtocolPaper(name){
    let code=protocolCode[name];
    hashHistory.push({
        pathname:'/WebView',
        state:{name:name,code:code},
        query: {code:code}
    })
  }
  isAgreeClick(){
    let { agreeIndex } =this.state;
    if (agreeIndex===0) {
      this.setState({
        agreeIndex:1
      })
    } else {
      this.setState({
        agreeIndex:0,
      })
    }
  }
  next(){
    const { 
      payInfoData,
      paymentText
    }=this.props;
    let {amount}=this.state;
    if (amount>paymentText) {
      Toast.info( '投资金额不可低于'+amount+'元', Util.ToastTime );
      return;
    }
    this.setState({
      pwdFlag:true
    })
  }
  keyOk(){
    const { 
      payInfoData,
      dispatch
    }=this.props;
    let {planItem,fundCode,fundName}=this.props.location.state;
    const pushResult=(i,result)=>{
      if (i===1) {
          Toast.hide() 
          hashHistory.push({
            pathname:'/Success',
            state: {
              title:'定投计划',
              content:'定投签约完成',
              dataSouse:[['申请编号',result.content.planId],['产品名称',fundName],['投资金额',this.props.paymentText+'元']],
              souseVal:['返回智投首页']
            }
          });
      } else if (i===3) {
          hashHistory.push({
            pathname:'/ErrorResult',
            state: {
              title:'定投计划',
              content:'定投签约失败',
              content2:result,
              dataSouse:[],
              souseVal:['返回智投首页','联系客服']
            }
          });
      }
    }
    if (planItem.type=='12') {
      console.log('修改活期通')
      let data={
       password:Util.encrypt(this.state.keyPasswordVal),
       tradeDates:this.state.pickerValue[1],
       tradeAmount:this.props.paymentText,
       planId:planItem.planId
      }
      dispatch(modifyPlan(data,pushResult))
    } else if(planItem.type=='0') {
      console.log('修改银行卡')
      let data={
       password:Util.encrypt(this.state.keyPasswordVal),
       fundCode:planItem.fundCode,
       periodTradeType:0,
       tradeDates:this.state.pickerValue[1],
       tradeAmount:this.props.paymentText,
       planId:planItem.planId
      }
      dispatch(modifyBuyPlan(data,pushResult))
    }else if(planItem.type=='11'||planItem.type=='2') {
      console.log(this.props)
      let data={
       password:Util.encrypt(this.state.keyPasswordVal),
       fundCode:planItem.convertOutFundCode,
       targetFundCode:planItem.fundCode,
       tradeDays:this.state.pickerValue[1],
       tradeAmount:this.props.paymentText,
       planId:planItem.planId,
       trustChannelId:this.props.location.state.trustChannelId
      }
      dispatch(moneyFundPlanModifyValidate(data,pushResult))
    }
  }
  choseBank(){
    hashHistory.push({
      pathname: '/paymentBankList',
      state:{
        fundCode:this.props.location.state.fundCode,
      }
    });
  }
  render(){
    const img_arr = [require('../../../img/square.png'),require('../../../img/protocol_selected.png')];
    let {payInfoData}=this.props;
    let {titleHeader,fundName,fundCode,planItem}=this.props.location.state;
    if (planItem.type=='12') {
      for (var i = 0; i < payInfoData.content.shareList.length; i++) {
        if (planItem.bankAccountShowNo==payInfoData.content.shareList[i].bankAccountShowNo) {
          accountTip='可用余额:'+Util.parsePrice(payInfoData.content.shareList[i].availableVolume)
          account=payInfoData.content.shareList[i].availableVolume
        }
      }
    }else if(planItem.type=='0'){
      for (var i = 0; i < payInfoData.content.currentAccountList.length; i++) {
        if (planItem.bankAccountShowNo==payInfoData.content.currentAccountList[i].bankAccountShowNo) {
          accountTip=payInfoData.content.currentAccountList[i].tradeMaxAmountTips.split("|")[1]
          account=payInfoData.content.currentAccountList[i].tradeMaxAmountTips.split("|")[0]
        }
      }
    }else if(planItem.type=='11'||planItem.type=='2'){
      payInfoData.content.currencyFund.forEach((x,i)=>{
        console.log(this.props.location.state)
        if (x.fundCode==planItem.convertOutFundCode&&x.trustChannelId==this.props.location.state.trustChannelId) {
          accountTip=`可用余额:${x.availableVolume}`
          account=x.availableVolume
        }
      })
    }
    return (
        <div className="container" >
          <NavigatorMain>
            <div className="header black">
              <div onClick={hashHistory.goBack}><span className="headerLeftBtn"></span></div>
              <div>{titleHeader}</div>
              <div></div>
            </div>
          </NavigatorMain>
          <div className='content'>
            <div className='fixed-invest-header'>
              <div className='fixed-invest-header-top'>
                {`${fundName}(${fundCode})`}
              </div>
              <div className='fixed-invest-header-bottom'>
                {`年化收益：${Util.fomatFloat(this.state.ThreeIncome,2)}%(${Util.returnDate(this.state.dayIncomeDate)})`}
              </div>
            </div>
            <div className='share'>
              <div className='shareTitle'>
                支付渠道
              </div>
            </div>
            <div className='fixed-invest-card-wrad' style={{marginBottom:10}}>
              {
                planItem.type=='11'||planItem.type=='2'?<div key='currentAccountList' className='bankList' >
                <img src={ require('../../../img/hqt.png')} className='img' style={{width:24,height:31}}/>
                <div className='bankListTip'>
                  <p>{planItem.convertOutFundName}<span style={{fontSize:12,color:'#5b6370'}}>{'('+Util.formatStr(planItem.trustChannelName)+')'}</span></p>
                  <p>{accountTip}</p>
                </div>
                {/* <div className='bankListRight'></div> */}
              </div>:<div key='currentAccountList' className='bankList' >
                <img src={ bankCode['ty'][planItem.bankCode]?bankCode['ty'][planItem.bankCode]:require('../../../img/bank.png')} className='img'/>
                <div className='bankListTip'>
                  <p>{planItem.trustChannelName?planItem.trustChannelName.split('*')[0]+'(*'+planItem.trustChannelName.split('*')[1]+')':'--'}</p>
                  <p>{accountTip}</p>
                </div>
                {/* <div className='bankListRight'></div> */}
              </div>
              }
              
            </div>
            <div className='input' >
              <p>每期投资金额(元)</p>
              <input autocomplete="off" value={this.props.paymentText}  className='dt-memony' placeholder={`最低投资金额${Util.parsePrice(this.state.amount)}元`}  onChange={(e)=>this.onChangeText(e.target.value)} type="text"  />
            </div>
            <Picker
              title="选择定投周期"
              extra={this.state.pickerValue}
              cols={2}
              data={this.state.dataSouse}
              value={this.state.pickerValue}
              onChange={v => {console.log(v);this.setState({ pickerValue: v })}}
            >
              <CustomChildren>扣款周期</CustomChildren>
            </Picker>
            <div className='dt-xy-box' >
              <img src={img_arr[this.state.agreeIndex]}  className='imgBtn' onClick={()=>this.isAgreeClick()}/>
              <p>我已阅读并同意<span className='red-t' onClick={()=>this.ProtocolPaper('华夏查理智投定期定额申请协议')}>《华夏查理智投定期定额申请协议》</span></p>
            </div>
            
            <PayWarmTips fundLimit={this.props.location.state.fundLimit} buyType='SF'/>
            {
              Util.regular1.test(this.props.paymentText)&&this.state.agreeIndex!==0?<div onClick={()=>this.next()} className='btn'>下一步</div>:
              <div  className='btn btn-gray'>下一步</div>
            }
          </div>
          
          {
            this.state.pwdFlag?
            <div  style={{position:'fixed',top:0,width:'100%',height:'100%',background:'rgba(52,52,52,0.4)'}}>
              <div style={{position:'fixed',bottom:0,width:'100%',height:'70%',background:'#fff'}}>
                <div style={{position:'relative',height:'45px',lineHeight:'45px',textAlign:'center',borderBottom:'0.005rem solid rgb(224,227,279)',fontSize:'0.3rem'}}>
                  交易密码
                  <img src={require('../../../img/close.png')}  style={{position:'absolute',left:0,width:'0.88rem',height:'0.88rem'}} onClick={()=>{this.setState({pwdFlag:false})}}/>
                  <span  style={{position:'absolute',top:0,right:0,width:'45px',fontSize:'13px'}} className='red-t' onClick={()=>{this.keyOk()}}> 确认</span>
                </div>
                <div style={{padding:'0.3rem 0.3rem 0rem 0.3rem',fontSize:'13px'}}>
                  {this.props.location.state.fundRisk?'温馨提示：本人已完成风险测评问卷，并对申请购买的基金产品风险等级高于本人的风险承受能力情况已知晓，并已充分了解该基金产品的风险特征和可能的不利后果。本人仍坚持自愿投资该基金产品，并自愿承担由此可能产生的一切不利后果和损失。基金募集机构及工作人员在销售过程中，不存在直接或间接主动向本人推介该基金产品或服务的行为。':''}
                </div>
                <div style={{height:'45px',padding:'13px'}}>
                  <input autocomplete="off" onChange={(e)=>this.onChangePwd(e.target.value)} autofocus="autofocus" style={{height:'45px',width:'100%',fontSize:'0.3rem',border:'1px solid #afafaf',borderRadius:'0.1rem'}} type="password"  placeholder=""/>
                </div>
              </div>
            </div>
            :null
          }
        </div>
    );
  }
}


function mapStateToProps(state, ownProps) {
  return {
    payInfoData:state.payInfo,
    paymentText:state.paymentText,
  }
}
export default connect(mapStateToProps)(FixedInvestmentSuperFund);



// WEBPACK FOOTER //
// ./src/components/myAssets/payment/FixedInvestmentSuperFundChange.js